import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

/**
 * Feel free to modify this type for this project (only) here
 * For example, if you add a whole new block of text that the jslib does not have a spot for already
 *
 * This is not necessary if you are just overriding text for a pre-existing message id
 */
type ThisProjectMessages = {
    optIn: string;
    step: {
        docUpload: {
            pleaseOmit: string;
        };
        success: {
            returnToLevis: string;
        };
    };
};

export const messagesES: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    optIn: "Me gustaría recibir comunicaciones de marketing, incluyendo correos electrónicos, de Levi's",
    step: {
        docUpload: {
            pleaseOmit: 'Omite, oculta o tacha cualquier información confidencial, como número de seguro social, número de identificación militar, etc. La información que SÍ necesitamos que sea visible: nombre, apellido, fechas válidas o estado, por ejemplo: "jubilado" o "en servicio activo".',
        },
        success: {
            returnToLevis: "Regresa a <a href='https://www.levi.com/US/en_US/' class='sid-link' target='_blank'>www.levis.com</a> para seguir comprando.",
        },
    },
};
